<template>
  <div>

    <!-- TABS -->
    <div class="bg-white rounded border-0 shadow-sm my-3">
    <div class="d-flex align-items-end py-3 pl-3 pr-3">
      <div class="d-flex flex-column">
        <h5 class="mb-1">Tabs</h5>
        <p class="text-gray-500">Basic tabs</p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : viewTab === 'preview'}" @click="viewTab = 'preview'">Preview</b-button>
        <b-button :class="{'active' : viewTab === 'code'}"  @click="viewTab = 'code'">Code</b-button>
      </ButtonGroup>
    </div>


    <CodePreviewViewer :viewMode="viewTab" :codeSample="require('@/components/local/Tabs/tab.js').default">
      <template v-slot:preview>
        <div class="w-100">
          <Tab :tabList="tabs">
            <template v-slot:tabPanel-1> Content 1 </template>
            <template v-slot:tabPanel-2> Content 2 </template>
            <template v-slot:tabPanel-3> Content 3 </template>
            <template v-slot:tabPanel-4> Content 4 </template>
          </Tab>
        </div>
      </template>
    </CodePreviewViewer>
    </div>

    

    <!-- TABS WITH COUNT -->
    <div class="my-3 bg-white rounded border-0 shadow-sm">
      <div class="d-flex align-items-end py-3 pl-3 pr-3 ">
        <div class="d-flex flex-column">
          <h5 class="mb-1">Tabs with Count</h5>
          <p class="text-gray-500">Tabs with count data</p>
        </div>
        <ButtonGroup>
          <b-button :class="{'active' : viewTabCount === 'preview'}" @click="viewTabCount = 'preview'">Preview</b-button>
          <b-button :class="{'active' : viewTabCount === 'code'}"  @click="viewTabCount = 'code'">Code</b-button>
        </ButtonGroup>
      </div>


      <CodePreviewViewer :viewMode="viewTabCount" :codeSample="require('@/components/local/Tabs/tab_count.js').default">
        <template v-slot:preview>
          <div class="w-100">
            <Tab :tabList="tabsCount">
              <template v-slot:tabPanel-1> Content 1 </template>
              <template v-slot:tabPanel-2> Content 2 </template>
              <template v-slot:tabPanel-3> Content 3 </template>
              <template v-slot:tabPanel-4> Content 4 </template>
            </Tab>
          </div>
        </template>
      </CodePreviewViewer>
    </div>



    <!-- TABS WITH ICON -->
    <div class="my-3 bg-white rounded border-0 shadow-sm">
      <div class="d-flex align-items-end py-3 pl-3 pr-3 mt-3">
        <div class="d-flex flex-column">
          <h5 class="mb-1">Tabs with Icon</h5>
          <p class="text-gray-500">Tabs with added icons from Font Awesome</p>
        </div>
        <ButtonGroup>
          <b-button :class="{'active' : viewTabIcon === 'preview'}" @click="viewTabIcon = 'preview'">Preview</b-button>
          <b-button :class="{'active' : viewTabIcon === 'code'}"  @click="viewTabIcon = 'code'">Code</b-button>
        </ButtonGroup>
      </div>


      <CodePreviewViewer :viewMode="viewTabIcon" :codeSample="require('@/components/local/Tabs/tab_icon.js').default">
        <template v-slot:preview>
          <div class="w-100">
            <Tab :tabList="tabsIcon">
              <template v-slot:tabPanel-1> Content 1 </template>
              <template v-slot:tabPanel-2> Content 2 </template>
              <template v-slot:tabPanel-3> Content 3 </template>
              <template v-slot:tabPanel-4> Content 4 </template>
            </Tab>
          </div>
        </template>
      </CodePreviewViewer>
    </div>
  </div>

</template>

<script>
import Tab from '@/components/export/Tabs/Tabs'
import ButtonGroup from '@/components/export/ButtonGroup/ButtonGroup'
import CodePreviewViewer from '@/components/local/CodePreviewViewer'

export default {
  components: { Tab, ButtonGroup, CodePreviewViewer },
  data () {
    return {
      viewTab: 'preview',
      viewTabCount: 'preview',
      viewTabIcon: 'preview',
      tabs: [
          { text: 'Tab 1'},
          { text: 'Tab 2'},
          { text: 'Tab 3'},
          { text: 'Tab 4'}
      ],

      tabsCount: [
          { text: 'Tab with Count 1', count: '23'},
          { text: 'Tab with Count 2', count: '5'},
          { text: 'Tab with Count 3', count: '17'},
          { text: 'Tab with Count 4', count: '0'}
      ],

      tabsIcon: [
          { text: 'Tab with Icon 1', icon: 'fa-calendar-alt' },
          { text: 'Tab with Icon 2', icon: 'fa-user-circle' },
          { text: 'Tab with Icon 3', icon: 'fa-envelope' },
          { text: 'Tab with Icon 4', icon: 'fa-gem'}
      ],
    }
  }
}
</script>